import { useMemo } from 'react';

import { VisitHistoryProcedure, VisitHistoryProcedureQuery } from '@dreryk/egabinet-visit-frontend-api';

import {
   LazyLoadedDataConfigurationByCqrsQuery,
   useLazyLoadedDataConfigurationByCqrsQuery,
} from '@dreryk/drerykweb-main-frontend';
import {
   AlignItems,
   createDynamicColumnsWidth,
   EmptyStatePlaceholder,
   JustifyContent,
   Table,
   TableColumnConfiguration,
} from '@dreryk/react-components';

import { visitHistoryTranslationKeys } from '../translations';

const useVisitHistoryProcedureDataConfiguration = (
   visitId: number
): LazyLoadedDataConfigurationByCqrsQuery<VisitHistoryProcedure> => {
   return useLazyLoadedDataConfigurationByCqrsQuery<VisitHistoryProcedure>(() => {
      const query = new VisitHistoryProcedureQuery();
      query.visitId = visitId;
      return query;
   });
};

const useVisitHistoryProcedureColumnsConfiguration =
   // eslint-disable-next-line max-lines-per-function
   (): TableColumnConfiguration<VisitHistoryProcedure>[] => {
      // eslint-disable-next-line max-lines-per-function
      return useMemo<TableColumnConfiguration<VisitHistoryProcedure>[]>(() => {
         const columnsWidth = createDynamicColumnsWidth({
            code: '76px',
            name: '100%',
            quantity: '82px',
         });

         return [
            {
               name: 'code',
               label: visitHistoryTranslationKeys.proceduresTable.code,
               width: columnsWidth.code,
               sortingDisabled: true,
               justifyContent: JustifyContent.START,
               alignItems: AlignItems.CENTER,
               accessor: (procedure) => procedure.code,
            },
            {
               name: 'name',
               label: visitHistoryTranslationKeys.proceduresTable.procedureName,
               width: columnsWidth.name,
               sortingDisabled: true,
               justifyContent: JustifyContent.START,
               alignItems: AlignItems.CENTER,
               accessor: (procedure) => procedure.name,
            },
            {
               name: 'quantity',
               label: visitHistoryTranslationKeys.proceduresTable.quantity,
               width: columnsWidth.quantity,
               sortingDisabled: true,
               justifyContent: JustifyContent.END,
               alignItems: AlignItems.CENTER,
               accessor: (procedure) => procedure.quantity,
            },
         ];
      }, []);
   };

type VisitHistoryProceduresTableProps = {
   readonly visitId: number;
};

export const VisitHistoryProceduresTable = (props: VisitHistoryProceduresTableProps): JSX.Element => {
   return (
      <Table
         testId={'procedures'}
         dataConfiguration={useVisitHistoryProcedureDataConfiguration(props.visitId)}
         columns={useVisitHistoryProcedureColumnsConfiguration()}
         keyExtractor={'id'}
         pageSize={1000}
         placeholder={
            <EmptyStatePlaceholder
               testId={'noProcedures'}
               heading={visitHistoryTranslationKeys.proceduresTable.noProcedures}
               subheading={visitHistoryTranslationKeys.proceduresTable.noMedicalProceduresSpecified}
            />
         }
         compact
      />
   );
};
